<template>
  <div class="comments">
    <inline-loader v-if="loading" :loading="loading" />
    <comments-list :comments="comments" v-else-if="comments.length" />
    <div class="ms-help ms-nodata" v-else>
      Комментарии отсутствуют
    </div>
    <comments-add-form type="contracts" :id="$route.params.id" @update="getComments" />
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import CommentsList from './comments-list'
import CommentsAddForm from './comments-add-form'

export default {
  data () {
    return {
      loading: false,
      comments: []
    }
  },
  components: {
    InlineLoader,
    CommentsList,
    CommentsAddForm
  },
  methods: {
    async getComments () {
      const { id } = this.$route.params

      try {
        this.loading = true
        const url = `page/comment?object_id=${id}&object_type=contracts`
        this.comments = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  created () {
    this.getComments()
  }
}
</script>

<style lang="less">

</style>
